<template>
    <footer id="footer">
        <p>&copy;2014 Forte Mice. All rights reserved. A brand of <a href="http://www.corporate.com.sg">Corporate Travel Services</a>.</p>
    </footer>
</template>

<script>
export default {
    name: 'AppFooter'
}
</script>

<style lang="less" scoped>
#footer {
    background: #000;
    bottom: 0;
    font-size: 0.714em;
    color: @lightColor;
    height: 50px;
    left: 0;
    position: fixed;
    right: 0;
    z-index: 50;

    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 5%;

    p {
        margin: 0;
        text-align: center;
    }
}
</style>